<template>
  <div>
    <a-modal title="Delete Trades Warning" width="900px" okText="Confirm" :visible="modal_delete_warning"
      cancelText="Cancel" @cancel="modal_delete_warning = false" @ok="delete_trade_please(trade_id_to_del)">
      <h1>{{ delete_trade_message }}</h1>

    </a-modal>
    <a-tabs defaultActiveKey="2">
      <a-tab-pane tab="Trades" key="1">
        <a-form layout="inline">
          <h3>Create New Trades:</h3>
          <a-form-item label="Date">
            <a-date-picker v-model="trade_to_create.date" style="width:120px" valueFormat="YYYY-MM-DD" />
          </a-form-item>

          <a-form-item label="Contract Ref">
            <a-input style="text-align:center;width:100px" v-model="trade_to_create.contract_ref" />
          </a-form-item>

          <a-form-item label="Delivert Start">
            <a-date-picker v-model="trade_to_create.delivery_shipment_start" style="width:120px"
              valueFormat="YYYY-MM-DD" />
          </a-form-item>

          <a-form-item label="Delivert End">
            <a-date-picker v-model="trade_to_create.delivery_shipment_end" style="width:120px"
              valueFormat="YYYY-MM-DD" />
          </a-form-item>

          <a-form-item label="Origin">
            <a-select style="width:100px" v-model="trade_to_create.origin">
              <a-select-option value="Brazil">Brazil</a-select-option>
              <a-select-option value="Argentina">Argentina</a-select-option>
              <a-select-option value="U.S.">U.S.</a-select-option>
              <a-select-option value="Ukraine">Ukraine</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Load Port">
            <a-select style="width:200px" v-model="trade_to_create.load_port">
              <a-select-option v-for="o in load_port" :value="o" :key="o">{{ o }}</a-select-option>
            </a-select>
          </a-form-item>

        </a-form>
        <a-form layout="inline">
          <a-form-item label="Direction">
            <a-select v-model="trade_to_create.direction" style="width:100px"
              @change="(e) => { if (e == 'Purchase') { trade_to_create.buyers = 'C&D'; trade_to_create.seller = '' } else { trade_to_create.seller = 'C&D'; trade_to_create.buyers = '' } }">
              <a-select-option value="Purchase">Purchase</a-select-option>
              <a-select-option value="Sales">Sales</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Seller">
            <a-select style="text-align:center;width:100px" v-model="trade_to_create.seller"
              @change="(e) => { $forceUpdate() }" :disabled="trade_to_create.direction == 'Sales'">
              <template v-if="trade_to_create.direction == 'Sales'">
                <a-select-option value="C&D">C&D</a-select-option>
              </template>
              <template>
                <a-select-option v-for="o in purchase_sellers" :value="o" :key="o">
                  {{ o }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>

          <a-form-item label="Buyer">
            <a-select style="text-align:center;width:100px" v-model="trade_to_create.buyers"
              @change="(e) => { $forceUpdate() }" :disabled="trade_to_create.direction == 'Purchase'">
              <template v-if="trade_to_create.direction == 'Purchase'">
                <a-select-option value="C&D">C&D</a-select-option>
              </template>
              <template>
                <a-select-option v-for="o in sales_buyers" :value="o" :key="o">
                  {{ o }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>

        </a-form>
        <a-form layout="inline">
          <a-form-item label="Mean Quantity">
            <a-input style="text-align:center;width:100px" v-model="trade_to_create.mean_quantity" type="number" min=0
              step=1 />
          </a-form-item>
          <a-form-item label="MOL(%)">
            <a-input style="text-align:center;width:100px" v-model="trade_to_create.mol" type="number" min=0 step=1 />
          </a-form-item>

          <a-form-item label="Act Quantity" v-if="trade_to_create.direction == 'Purchase'">
            <a-input style="text-align:center;width:100px" v-model="trade_to_create.actual_quantity" type="number" min=0
              step=1 />
          </a-form-item>

          <a-form-item label="Freight" v-if="trade_to_create.direction == 'Purchase'">
            <a-input style="text-align:center;width:100px" v-model="trade_to_create.freight" type="number" min=0
              step=0.01 />
          </a-form-item>

          <a-form-item label="Is Loaded?" v-if="trade_to_create.direction == 'Purchase'">
            <a-select style="width:100px" v-model="trade_to_create.is_load">
              <a-select-option value="yes">Yes</a-select-option>
              <a-select-option value="no">No</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
        <a-form layout="inline">
          <a-form-item label="Trade Type">
            <a-select v-model="trade_to_create.trade_type" style="width:100px">
              <a-select-option value="FOB">FOB</a-select-option>
              <a-select-option value="CFR">CFR</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Cargo">
            <a-select style="width:100px" v-model="trade_to_create.cargo">
              <a-select-option v-for="o in cargo" :velue="o" :key=o>{{ o }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Futruex Symbol">
            <a-auto-complete style="width:100px;text-align:center" v-model="trade_to_create.futures"
              :data-source="symbols_to_suggest"
              @search="(e) => { symbols_to_suggest = symbols.filter(s => s.match(e)) }" />
          </a-form-item>

          <a-form-item label="Contract Basis">
            <a-input type="number" step=0.01 v-model="trade_to_create.basis" style="width:100px" />
          </a-form-item>

          <a-form-item label="North China Basis" v-if="trade_to_create.trade_type == 'CFR'">
            <a-input type="number" step=0.01 v-model="trade_to_create.nchina_basis" style="width:100px" />
          </a-form-item>

        </a-form>
        <a-button size="large" type="primary" style="display:block;margin:10px auto;width:500px" @click="add_trade">Add
          Trade
        </a-button>
        <a-alert message="Trades Changes Haven't Been Saved" banner v-if="unsaved_trades" />
        <a-tabs>
          <a-tab-pane v-for="t in ['Purchase', 'Sales']" :tab=t :key="t">
            <a-table size="small" rowKey="id" :columns="trades_column"
              :dataSource="trades.filter(tr => tr.direction == t)">
              <template slot="delivery_shipment_start" slot-scope="record">
                <a-date-picker size="small" valueFormat="YYYY-MM-DD" v-model="record.delivery_shipment_start"
                  style="width:120px"></a-date-picker>
              </template>
              <template slot="delivery_shipment_end" slot-scope="record">
                <a-date-picker size="small" valueFormat="YYYY-MM-DD" v-model="record.delivery_shipment_end"
                  style="width:120px"></a-date-picker>
              </template>
              <template slot="contract_ref" slot-scope="record">
                <a-input size="small" v-model="record.contract_ref" style="width:100px;text-align:center"></a-input>
              </template>

              <template slot="futures" slot-scope="record">
                <a-auto-complete size="small" style="width:100px;text-align:center" v-model="record.futures"
                  :data-source="symbols_to_suggest"
                  @search="(e) => { symbols_to_suggest = symbols.filter(s => s.match(e)) }" />
              </template>

              <template slot="basis" slot-scope="record">
                <a-input size="small" type="number" min=0 step=0.01 v-model="record.basis"
                  style="width:100px;text-align:center"></a-input>
              </template>

              <template slot="nchina_basis" slot-scope="record" v-if="record.trade_type == 'CFR'">
                <a-input size="small" type="number" min=0 step=0.01 v-model="record.nchina_basis"
                  style="width:100px;text-align:center"></a-input>
              </template>

              <template slot="trade_type" slot-scope="record">
                <a-select size="small" v-model="record.trade_type" style="width:60px;text-align:center">
                  <a-select-option value="FOB">FOB</a-select-option>
                  <a-select-option value="CFR">CFR</a-select-option>
                </a-select>
              </template>

              <template slot="buyer" slot-scope="record">
                <a-input size="small" v-model="record.buyers" v-if="record.direction == 'Purchase'"
                  :disabled="record.direction == 'Purchase'" style="width:100px;text-align:center"></a-input>
                <a-select size="small" v-else style="text-align:center;width:120px" v-model="record.buyers"
                  @change="(e) => { $forceUpdate() }">
                  <template>
                    <a-select-option v-for="o in sales_buyers" :value="o" :key="o">
                      {{ o }}
                    </a-select-option>
                  </template>
                </a-select>
              </template>
              <template slot="seller" slot-scope="record">
                <a-input size="small" v-model="record.seller" v-if="record.direction == 'Sales'"
                  :disabled="record.direction == 'Sales'" style="width:100px;text-align:center"></a-input>
                <a-select size="small" v-else style="text-align:center;width:120px" v-model="record.seller"
                  @change="(e) => { $forceUpdate() }">
                  <template>
                    <a-select-option v-for="o in purchase_sellers" :value="o" :key="o">
                      {{ o }}
                    </a-select-option>
                  </template>
                </a-select>
              </template>
              <template slot="load_port" slot-scope="record">
                <a-select size="small" style="width:200px" v-model="record.load_port">
                  <a-select-option v-for="o in load_port" :value="o" :key="o">{{ o }}</a-select-option>
                </a-select>
              </template>

              <template slot="origin" slot-scope="record">
                <a-select size="small" v-model="record.origin" style="width:100px;text-align:center">
                  <a-select-option value="USA">USA</a-select-option>
                  <a-select-option value="Argentina">Argentina</a-select-option>
                  <a-select-option value="Brazil">Brazil</a-select-option>
                  <a-select-option value="Ukraine">Ukraine</a-select-option>
                </a-select>
              </template>
              <template slot="cargo" slot-scope="record">
                <a-select size="small" style="width:120px" v-model="record.cargo">
                  <a-select-option v-for="o in cargo" :value="o" :key="o">{{ o }}</a-select-option>
                </a-select>
              </template>
              <template slot="freight" slot-scope="record" v-if="record.direction == 'Purchase'">
                <a-input size="small" v-model="record.freight" type="number" step=0.01 min=0
                  style="width:80px;text-align:center"></a-input>
              </template>
              <template slot="loaded" slot-scope="record">
                <a-select size="small" style="width:60px" v-model="record.is_load"
                  v-if="record.direction == 'Purchase'">
                  <a-select-option value="yes">Yes</a-select-option>
                  <a-select-option value="no">No</a-select-option>
                </a-select>
              </template>

              <template slot="ops" slot-scope="record">
                <a-popconfirm title="Are you sure delete this Trade?" ok-text="Yes" cancel-text="No"
                  @confirm="del_trade(record.id)">
                  <a-button size="small" type="link">Delete</a-button>
                </a-popconfirm>
              </template>

              <div slot="expandedRowRender" slot-scope="record">
                <a-form layout="inline">
                  <h5>Orgination:</h5>
                  <a-form-item label="Cargo:">
                    <a-select size="small" style="width:120px" v-model="record.cargo">
                      <a-select-option v-for="o in cargo" :value="o" :key="o">{{ o }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Origin:">
                    <a-select size="small" v-model="record.origin" style="width:100px;text-align:center">
                      <a-select-option value="USA">USA</a-select-option>
                      <a-select-option value="Argentina">Argentina</a-select-option>
                      <a-select-option value="Brazil">Brazil</a-select-option>
                      <a-select-option value="Ukraine">Ukraine</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Load Port:">
                    <a-select size="small" style="width:120px" v-model="record.load_port">
                      <a-select-option v-for="o in load_port" :value="o" :key="o">{{ o }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <h5>Others:</h5>
                  <a-form-item label="Date">
                    <a-date-picker size="small" valueFormat="YYYY-MM-DD" v-model="record.date"
                      style="width:100px"></a-date-picker>
                  </a-form-item>
                  <a-form-item label="Pre-advice">
                    <a-input size="small" type='number' step=1 min=0 v-model="record.pre_advise"
                      style="width:100px;text-align:center" />
                  </a-form-item>
                  <h5>Quantity:</h5>
                  <a-form-item label="Actual Quantity" v-if="record.direction == 'Purchase'">
                    <a-input size="small" v-model="record.act_quantity" type="number"
                      style="text-align:center;"></a-input>
                  </a-form-item>
                  <a-form-item label="Mean Quantity">
                    <a-input size="small" v-model="record.mean_quantity" type="number"
                      style="text-align:center;"></a-input>
                  </a-form-item>
                  <a-form-item label="MOL(%)">
                    <a-input size="small" v-model="record.mol" type="number" style="text-align:center;"></a-input>
                  </a-form-item>
                  <h5>Pricing:</h5>
                  <a-form-item label="Futures Req. Mean">
                    <a-input size="small" v-model="record.required_mean" type="number"
                      style="text-align:center;"></a-input>
                  </a-form-item>
                  <a-form-item label="Pricing Progress(Done/BL):">
                    <a-input size="small" v-model="record.futures_done" type="number"
                      style="text-align:center;"></a-input>
                  </a-form-item>
                  <a-form-item label="/" :colon="false">
                    <a-input size="small" v-model="record.required_bl" type="number" style="text-align:center;" />
                  </a-form-item>
                  <a-form-item label="Averge(Cents/Bushel)">
                    <a-input size="small" v-model="record.avg_fut_price" type="number" style="text-align:center;" />
                  </a-form-item>
                  <a-form-item label="Flat(USD/ton)">
                    <a-input size="small" v-model="record.flat" type="number" style="text-align:center;" />
                  </a-form-item>
                  <h5>Remarks:</h5>
                  <a-textarea size="small" v-model="record.remarks" rows="5"></a-textarea>
                </a-form>
              </div>
            </a-table>
          </a-tab-pane>
        </a-tabs>
        <a-button size="large" type="primary" style="display:block;margin:30px auto;width:500px"
          @click="save_trades">Save</a-button>
      </a-tab-pane>
      <a-tab-pane tab="Matching2" key="2">
        <a-form layout="inline">
          <h3>Create New Trades:</h3>
          <a-form-item label="Vessel">
            <a-input v-model="match_to_create.vessel" />
          </a-form-item>

          <a-form-item label="ETA">
            <a-date-picker v-model="match_to_create.eta" valueFormat="YYYY-MM-DD" />
          </a-form-item>

          <a-form-item label="ETB">
            <a-date-picker v-model="match_to_create.etb" valueFormat="YYYY-MM-DD" />
          </a-form-item>

          <a-form-item label="BL/Date">
            <a-date-picker v-model="match_to_create.bl_date" valueFormat="YYYY-MM-DD" />
          </a-form-item>
        </a-form>
        <a-button size="large" type="primary" style="display:block;margin:30px auto;width:500px" @click="add_match">
          Create
        </a-button>
        <a-table size="small" :columns="match_column" rowKey="id" :dataSource="trade_match">
          <template slot="vessel" slot-scope="record">
            <a-input size="small" v-model="record.vessel_name" style="text-align:center" />
          </template>
          <template slot="eta" slot-scope="record">
            <a-date-picker size="small" v-model="record.eta" valueFormat="YYYY-MM-DD"></a-date-picker>
          </template>

          <template slot="etb" slot-scope="record">
            <a-date-picker size="small" v-model="record.etb" valueFormat="YYYY-MM-DD"></a-date-picker>
          </template>

          <template slot="bl_date" slot-scope="record">
            <a-date-picker size="small" v-model="record.bl_date" valueFormat="YYYY-MM-DD"></a-date-picker>
          </template>

          <template slot="ops">
            <a-popconfirm title="Are you sure delete this Vessel?" ok-text="Yes" cancel-text="No" @confirm="() => { }">
              <a-button size="small" type="link">Delete</a-button>
            </a-popconfirm>
          </template>
          <div slot="expandedRowRender" slot-scope="record,index">
            <a-form layout="inline">
              <h2>Purchase(Mean Quantity:{{ trades.reduce((acc, t) => {
                if (record.purchase_trade_ids.findIndex(pt => pt.id == t.id) != -1) {
                  return acc + Number.parseInt(t.mean_quantity)
                } else {
                  return acc
                }
              }, 0) }}MT):</h2>
              <a-form-item label="Purchase">
                <a-select style="width:500px" v-model="selected_purchase_id[index]">
                  <a-select-option v-for="t in trades" :key="index + '_' + t.id">{{ t.id }}===={{ t.contract_ref }}/{{
                    t.seller
                  }}->{{ t.buyers }}/{{ t.delivery_shipment_start }}---{{ t.delivery_shipment_end }}/{{ t.origin }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="() => {
                  record.purchase_trade_ids.push({ id: selected_purchase_id[index] })
                }">ADD Purchase</a-button>
              </a-form-item>
            </a-form>
            <a-form>
              <a-form-item label="Selected Purchase(Click to Remove)">
                <a-space>
                  <a-card :title="trades.find(tr =>
                    tr.id == pt.id).contract_ref + '/' + trades.find(tr =>
                      tr.id == pt.id).seller + '->' + trades.find(tr =>
                        tr.id == pt.id).buyers + '/' + trades.find(tr =>
                          tr.id == pt.id).delivery_shipment_start + '---' + trades.find(tr =>
                            tr.id == pt.id).delivery_shipment_end" v-for="(pt, pt_pos) in record.purchase_trade_ids"
                    :key="index + '_' + pt_pos">
                    <a slot="extra" href="#">
                      <a-popconfirm title="Are you sure to remove this Purchase?" ok-text="Yes" cancel-text="No"
                        @confirm="() => {
                          record.purchase_trade_ids.splice(pt_pos, 1)
                        }">
                        <a-button type="link">delete</a-button>
                      </a-popconfirm></a>
                    <a-form>
                      <a-form-item label="Price Adjustment">
                        <a-input v-model="pt.adjustment" type="number" step="1" />
                      </a-form-item>
                      <a-form-item label="Adjustment Comment">
                        <a-input v-model="pt.comment" />
                      </a-form-item>
                    </a-form>
                  </a-card>
                </a-space>
              </a-form-item>
            </a-form>
          </div>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="Result" key="3">
        <a-alert message="Trades Changes Haven't Been Saved" banner v-if="unsaved_trades" />
        <a-button size="large" type="primary" style="display:block;margin:30px auto;width:500px"
          @click="save_trades">Save</a-button>
        <table class="result_table" cellpadding="3">
          <!-- <template v-for="v in vessels">
            <tbody :key="v.id">
              <tr class="header">
                <td>Vessel</td>
                <td>ETA</td>
                <td>ETB</td>
                <td>BL/DATE</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{{ v.vessel }}</td>
                <td>{{ v.eta }}</td>
                <td>{{ v.etb }}</td>
                <td>{{ v.bl_date }}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>{{ v.actual_quantity }}</td>
                <td></td>
              </tr>
              <tr class="title">
                <td>Contract Ref.(Purchase)</td>
                <td>Seller</td>
                <td>Buyer</td>
                <td>Shipment Start</td>
                <td>Shipment End</td>
                <td>Type</td>
                <td>Basis</td>
                <td>Freight</td>
                <td>Act. Quantity</td>
                <td>Mean </td>
              </tr>

              <template v-for='(flow) in v.trade_basket'>
                <tr :key="flow.purchase_id">
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).contract_ref }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).seller }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).buyers }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).delivery_shipment_start }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).delivery_shipment_end }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).trade_type }}</td>
                  <td><input size="small" style="width:80px;text-align:center"
                      v-model="trades.find(tr => tr.id == flow.purchase_id).basis"></td>
                  <td><input size="small" v-model="trades.find(tr => tr.id == flow.purchase_id).freight"
                      style="width:80px;text-align:center"></td>
                  <td><input size="small" v-model="trades.find(tr => tr.id == flow.purchase_id).act_quantity"
                      style="width:80px;text-align:center"></td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).mean_quantity }}</td>
                </tr>
                <template v-for="(sa) in flow.sales">
                  <tr :key="sa.sales_id">
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).contract_ref }}</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).seller }}</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).buyers }}</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).delivery_shipment_start }}</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).delivery_shipment_end }}</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).trade_type }}</td>
                    <td><input size="small" style="width:80px;text-align:center"
                        v-model="trades.find(tr => tr.id == sa.sales_id).basis" /></td>
                    <td>-</td>
                    <td>-</td>
                    <td>{{ trades.find(tr => tr.id == sa.sales_id).mean_quantity }}</td>
                  </tr>
                </template>
                <tr class="title" :key="flow.purchase_id * 10">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Trade Pattern</td>
                  <td>Realised P/L</td>
                  <td>Left.</td>
                  <td></td>
                </tr>
                <tr :key="flow.purchase_id * 100">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ get_trade_pattern(flow) }}</td>
                  <td>{{ profit_calc(flow) }}</td>
                  <td>{{ trades.find(tr => tr.id == flow.purchase_id).mean_quantity - flow.sales.reduce((acc, cv) => {
                    return
                    acc +
                      Number.parseInt(trades.find(tr => tr.id == cv.sales_id).mean_quantity)
                  }, 0) }}</td>
                  <td></td>
                </tr>
              </template>
              <tr>
                <td>-</td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td></td>
              </tr>
              <tr>
                <td>-</td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td></td>
              </tr>

            </tbody>

          </template> -->
        </table>
      </a-tab-pane>
    </a-tabs>

  </div>

</template>


<script>
import _m from 'moment'

Array.prototype.my_trade_month_filter = function (trades, month) {
  var result = this;
  result = result.filter(r => {
    if (month == "") {
      return true
    } else {
      let flag = false
      if (new _m(trades.find(tr => tr.id == r.trade_id).delivery_shipment_start, "YYYY-MM-DD").format("MMM-YYYY") == month) {
        flag = true
      }
      return flag
    }
  })
  return result;
};

Array.prototype.my_vessel_filter = function (kw) {
  var result = this;
  result = result.filter(r => {
    if (kw == "") {
      return true
    }
    var match = r.vessel.toUpperCase().match(kw.toUpperCase());
    if (match) {
      return true;
    } else {
      return false;
    }
  })
  return result;
};


export default {
  name: "trade_profit",
  data() {
    return {
      modal_delete_warning: false,
      delete_trade_message: "",
      trade_id_to_del: "",

      console,

      symbols: [],
      symbols_to_suggest: [],
      trades_month: [],
      month_selector: "",
      vessel_kw: "",


      purchase_sellers: [
        "Amaggi",
        "Marubeni",
        "Gavilon",
        "Olam",
        "Cutrale",
        "ADM",
        "Bunge",
        "LDC",
        "Cofco Int",
        "Cofco BJ",
        "XingLong",
      ],
      sales_buyers: [
        "Hopeful",
        "Cofco Int",
        "Cofco BJ",
        "Zhonghe",
        "Changde",
        "Jijia",
        "DDQ",
        "Yide",
        "Bangqi",
        "Olam",
        "LDC",
        "XingLong",
      ],
      load_port: [
        "Santos",
        "Paranagua",
        "SFDS",
        "Tubarao",
        "Itaqui",
        "Barcarena",
        "Rio Grande",
        "Aratu",
        "Mississippi River",
        "PNW",
        "Upriver + BB / Necochea",
        "Upriver Only",
        "BB / Necochea Only"
      ],
      cargo: ["Soybean", "Corn"],

      trades: [],
      trade_to_create: {},
      trades_column: [
        {
          title: "ID",
          align: "center",
          dataIndex: "id"
        },
        {
          title: "Contract Ref.",
          align: "center",
          scopedSlots: {
            customRender: "contract_ref"
          }
        },
        {
          title: "Trade Type",
          align: "center",
          scopedSlots: {
            customRender: "trade_type"
          }
        },
        {
          title: "Futures",
          align: "center",
          scopedSlots: {
            customRender: "futures"
          }
        },

        {
          title: "Contract Basis",
          align: "center",
          scopedSlots: {
            customRender: "basis"
          }
        },
        {
          title: "North Chian Basis",
          align: "center",
          scopedSlots: {
            customRender: "nchina_basis"
          }
        },
        {
          title: "Freight",
          align: "center",
          scopedSlots: {
            customRender: "freight"
          }
        },
        {
          title: "Seller",
          align: "center",
          scopedSlots: {
            customRender: "seller"
          }
        },
        {
          title: "Buyer",
          align: "center",
          scopedSlots: {
            customRender: "buyer"
          }
        },
        {
          title: "Delivery/Shipment",
          children: [
            {
              title: 'Start',
              align: "center",
              scopedSlots: {
                customRender: "delivery_shipment_start"
              }
            },
            {
              title: 'End',
              align: "center",
              scopedSlots: {
                customRender: "delivery_shipment_end"
              }
            },
          ]
        },
        {
          title: "Is Loaded?",
          align: "center",
          scopedSlots: {
            customRender: "loaded"
          }
        },
        {
          title: "Ops",
          align: "center",
          scopedSlots: {
            customRender: "ops"
          }
        },


      ],

      ignore_unsaved_trade: true,
      unsaved_trades: false,

      match_to_create: {},
      match_column: [
        {
          title: "ID",
          align: "center",
          dataIndex: "id"
        },
        {
          title: "Vessel",
          align: "center",
          scopedSlots: {
            customRender: "vessel"
          }
        },
        {
          title: "ETA",
          align: "center",
          scopedSlots: {
            customRender: "eta"
          }
        },
        {
          title: "ETB",
          align: "center",
          scopedSlots: {
            customRender: "etb"
          }
        },
        {
          title: "BL Date",
          align: "center",
          scopedSlots: {
            customRender: "bl_date"
          }
        },
        {
          title: "Purchase",
          align: "center",
          scopedSlots: {
            customRender: "puchase"
          }
        },
        {
          title: "Ops",
          align: "center",
          scopedSlots: {
            customRender: "ops"
          }
        },
      ],
      trade_match: [],
      selected_purchase_id: [],

      ignore_unsaved_vessel: true,
      unsaved_vessels: false,
      available_purchase: [],
      available_sales: []
    }
  },
  mounted() {
    this.refresh()
  },

  methods: {
    refresh() {
      this.symbols = []
      let commods = ['ZS', 'ZC', 'ZW']
      let month = ['F', 'G', "H", 'J', "K", "M", "N", "Q", "U", "V", "X", "Z"]
      let years = [new _m().subtract(1, 'years').format("YY"), new _m().format("YY"), new _m().add(1, 'years').format("YY"), new _m().add(2, 'years').format("YY")]
      commods.forEach(c => {
        years.forEach(y => {
          month.forEach(m => {
            this.symbols.push(c + m + y)
          })
        })
      })
      this.symbols_to_suggest = this.symbols
      this.trades_month = []
      this.$http.post(this.$store.state.base_url + "/tt/r", {}).then((res1) => {
        if (res1.data.status == 1) {
          this.ignore_unsaved_trade = true
          this.trades = res1.data.data
          this.trades.forEach(tr => {
            var start = new _m(tr.delivery_shipment_start, "YYYY-MM-DD").format('MMM-YYYY')
            if (this.trades_month.findIndex(tm => tm == start) == -1) {
              this.trades_month.push(start)
            }
          })
          this.trade_match = []
          this.$http.post(this.$store.state.base_url + "/trade_match/r", {}).then(res => {
            if (res.data.status == 1) {
              this.trade_match = res.data.data
              this.available_purchase = [...this.trades.filter(tr => tr.direction == "Purchase")]
              this.trade_match.forEach(tm => {
                tm.purchase_trade_ids.forEach(p_id => {
                  let purchase_found_pos = this.available_purchase.findIndex(ap => ap.id == p_id.id)
                  if (purchase_found_pos >= 0) {
                    this.available_purchase.splice(purchase_found_pos, 1)
                  }
                })
              })
            }
          })
        }
      })


    },

    // trades
    save_trades() {
      this.$http.post(this.$store.state.base_url + "/tt/u", this.trades).then(res => {
        if (res.data.status == 1) {
          this.$message.info("Save Trades OK!")
          this.unsaved_trades = false
        }
      })
    },
    add_trade() {
      if (!this.trade_to_create.hasOwnProperty("direction")) {
        this.$message.error("Please Select Trade Direction")
        return
      }
      this.$http.post(this.$store.state.base_url + "/tt/c", this.trade_to_create).then(res => {
        if (res.data.status == 1) {
          this.ignore_unsaved_trade = true
          this.trades.push(res.data.data[0])
          if (res.data.data[0].direction == "Purchase") {
            console.log("add purchase")
          }
          this.$message.info("Add Trades OK!")
        }
      })
    },
    del_trade(id) {
      var found = false
      this.vessels.forEach(v => {
        v.trade_basket.forEach(tb => {
          if (tb.purchase_id == id) {
            this.delete_trade_message = "This Purchase Exist in Veseel:  " + v.vessel + "   ID:    " + v.id + " / Are You Wish To Proceed?"
            this.modal_delete_warning = true
            this.trade_id_to_del = id
            found = true
          }
          tb.sales.forEach(sa => {
            if (sa.sales_id == id) {
              this.delete_trade_message = "This Sales Exist in Veseel:  " + v.vessel + "   ID:    " + v.id + " / Purchase Contract: " + this.trades.find(tr => tr.id == tb.purchase_id).contract_ref + " ID: " + this.trades.find(tr => tr.id == tb.purchase_id).id + " / Are You Wish To Proceed?"
              this.modal_delete_warning = true
              this.trade_id_to_del = id
              found = true
            }
          })
        })
      })
      if (!found) {
        this.delete_trade_please(id)
      }
    },
    delete_trade_please(id) {
      this.$http.post(this.$store.state.base_url + "/tt/d", { id: id }).then(res => {
        if (res.data.status == 1) {
          this.modal_delete_warning = true
          this.ignore_unsaved_trade = true
          var vessel_index = -1
          var flow_index = -1
          this.vessels.forEach((v, v_index) => {
            v.trade_basket.forEach((tb, f_index) => {
              if (tb.purchase_id == id) {
                tb.sales.forEach(sa => {
                  this.available_sales.push({ trade_id: sa.sales_id })
                })
                vessel_index = v_index
                flow_index = f_index
              }
              tb.sales.forEach(sa => {
                if (sa.sales_id == id) {
                  this.available_purchase.push({ trade_id: tb.purchase_id })
                  vessel_index = v_index
                  flow_index = f_index
                }
              })
            })
          })
          console.log("vessel index:", vessel_index)
          console.log("flow index:", flow_index)

          if (vessel_index !== -1 & flow_index !== -1) {
            this.vessels[vessel_index].trade_basket.splice(flow_index, 1)
            this.$http.post(this.$store.state.base_url + "/vt/u", this.vessels).then(res => {
              if (res.data.status == 1) {
                this.trades.splice(this.trades.findIndex(t => t.id == id), 1)
              }
            })
          } else {
            this.available_purchase = this.available_purchase.filter(avp => avp.trade_id !== id)
            this.available_sales = this.available_sales.filter(avs => avs.trade_id !== id)
            this.trades.splice(this.trades.findIndex(t => t.id == id), 1)
          }

          this.modal_delete_warning = false
          this.$message.info("Del Trades OK!")
        }
      })
    },

    //match 
    add_match() { },

    //summary 
    get_trade_pattern(flow) {
      let purchase_type = this.trades.find(tr => tr.id == flow.purchase_id).trade_type
      let sales_type = "none"
      if (flow.sales.length !== 0) {
        sales_type = this.trades.find(tr => tr.id == flow.sales[0].sales_id).trade_type
      }
      return purchase_type + "-" + sales_type
    },
    profit_calc(flow) {
      let freight = this.trades.find(tr => tr.id == flow.purchase_id).freight
      let purchase = this.trades.find(tr => tr.id == flow.purchase_id)
      let purchase_sum_prod_basis = purchase.act_quantity * (purchase.basis * 0.367433)
      let purchase_sum_prod_feight = purchase.act_quantity * freight
      let sales_sum_prod_basis = 0

      if (purchase.basis == "") {
        return "Empty Purchase Basis"
      }
      if (purchase.act_quantity == "") {
        return "Empty Purchase Act Quantity"
      }

      let empty_sales_flag = false
      flow.sales.forEach(sa => {
        let sales = this.trades.find(tr => tr.id == sa.sales_id)
        if (sales.basis == "") {
          empty_sales_flag = true
        }
        sales_sum_prod_basis = purchase.act_quantity * (sales.basis * 0.367433)
      })
      if (empty_sales_flag) {
        return "Empty Sales Basis"
      }
      let trade_pattern = this.get_trade_pattern(flow)
      if (trade_pattern == "FOB-FOB" | trade_pattern == "CFR-CFR") {
        return (sales_sum_prod_basis - purchase_sum_prod_basis).toFixed(2)
      } else if (trade_pattern == "FOB-CFR") {
        if (freight == "") {
          return "Empty Freight"
        } else {
          return (sales_sum_prod_basis - purchase_sum_prod_basis - purchase_sum_prod_feight).toFixed(2)
        }
      } else {
        return "Flow Not Complete"
      }
    }
  },

  watch: {
    trades: {
      deep: true,
      handler(n, o) {
        if (!this.ignore_unsaved_trade) {
          this.unsaved_trades = true
        }
        this.ignore_unsaved_trade = false
      }
    },

    trade_match: {
      deep: true,
      handler(n, o) {
      }
    },
  }



}
</script>

<style lang="scss" scoped>
.unalloc_trade {
  display: inline-block;
  margin: 5px;
  width: 45%;
  min-height: 150px;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  border-radius: 5px;
  vertical-align: top;

  .trade_card {
    border-radius: 5px;
    background-color: palegoldenrod;
    display: inline-block;
    margin: 10px;
    padding: 5px;
    cursor: pointer;
  }

  .ref {
    min-width: 80px;
    min-height: 25px;
    line-height: 25px;
    font-weight: 900;
    text-align: center;
  }

  .ref::before {
    content: 'REF:';
  }

  .contents {
    font-size: 10px;
  }
}

.vessel_container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.vessel {
  width: 48%;
  display: flex;
  flex-direction: column;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 10px;

  .vessel_info {
    text-indent: 30px;
  }

  .trade_flow_container {
    border-radius: 5px;
    width: 90%;
    margin: 5px auto;
    height: 100%;

    .trade_flow {
      background-color: aqua;
      display: flex;
      margin: 5px auto;
      width: 100%;
      border-radius: 5px;

      .purchase {
        width: 380px;
        margin: 5px;
        display: block;

        .ref {
          font-weight: 900;
          text-align: center;
          width: 200px;
        }

        .contents {
          font-size: 10px;
        }
      }

      .sales_container {
        background-color: purple;
        width: 100%;
        display: flex;
        border-radius: 5px;

        .sales {
          width: 300px;
          margin: 10px;
          background-color: violet;
          border-radius: 5px;
          cursor: pointer;
          padding: 5px;

          .ref {
            font-weight: 900;
            text-align: center;
          }

          .contents {
            font-size: 10px;
          }
        }
      }
    }
  }
}

.result_table {
  width: 100%;
  text-align: center;

  .header {
    border-bottom: 1px solid #000;
    font-weight: 900;
  }

  .title {
    font-weight: 900;
  }
}
</style>>
